/**
 * The one screen in ONDO that answers somebody with no account.
 *
 * Most of this copy is spent saying what the page cannot tell you. That is not
 * apology: a visitor who assumes a viewing room is the registry will read the
 * absence of a location as the work having none, and a collector who assumes the
 * same will put the wrong work in a room.
 */
export const ROOM_COPY = {
  loading: "Opening this room…",

  missingTitle: "This room isn’t open",
  missing:
    "The link may be mistyped, or the room may have been closed. The registry gives the same answer to both, deliberately — a viewing room’s address is the only thing keeping it private, so it does not confirm which rooms exist.",

  emailLead:
    "Enter your email address to go in. It is recorded with your visit so whoever opened this room knows who has looked. Nothing is checked and nothing is sent to it.",
  emailLabel: "Email address",
  emailAction: "Enter the room",
  emailRequired: "Enter an email address to go in.",

  memberLead:
    "You are signed in to ONDO, so you go straight in — and the person who opened this room will see your name against the visit.",

  passwordLead:
    "This room is closed with a password. Ask whoever sent you the link for it. Being signed in to ONDO is not enough, and nothing about the works is shown until it is right.",
  passwordLabel: "Password",
  passwordAction: "Unlock the room",

  refusedTitle: "Too many tries",
  refused:
    "This room has stopped answering for now. Wait a few minutes, or ask whoever sent you the link.",

  by: "Shared by",
  visitRecorded: "Your visit has been recorded for whoever opened this room.",

  footnote:
    "This room shows what its owner chose to show. Where these works are kept, who holds them and which collection they belong to are not part of it, and this page could not say even if you asked.",

  back: "← Back to the room",
  view: "View",

  chainTitle: "Chain of title",
  chainHelp:
    "The work’s history as the registry holds it. Each link is a claim somebody recorded; the registry does not settle them.",
  chainPresent: "to the present",
  chainEmpty: "Nothing has been recorded for this work.",

  noImage: "No photograph",
  imageOf: "Photograph",

  unknownError: "Something went wrong. Try the link again.",
} as const;

/** Where a link's two halves have to look like a handle and a slug. */
export const HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]{1,28}[a-z0-9]$/;
export const SLUG_PATTERN = /^[a-z0-9]{22}$/;

/*
 * How a link's method reads is NOT defined here. `METHOD_EVENTS` in
 * provenance.constants.ts already says what every method is called and what
 * tone it carries, and a second map would let the same chain read one way on
 * the collector's screen and another on the page they sent to a client.
 */
